import { render, staticRenderFns } from "./MatchmakingContainer.vue?vue&type=template&id=e9a33738&scoped=true"
import script from "./MatchmakingContainer.vue?vue&type=script&lang=js"
export * from "./MatchmakingContainer.vue?vue&type=script&lang=js"
import style0 from "./MatchmakingContainer.vue?vue&type=style&index=0&id=e9a33738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a33738",
  null
  
)

export default component.exports